import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Septoplasty Surgery in Delhi, India | Treatment, Cost & Doctors</title>
            <meta name="description" content="Get expert Septoplasty surgery with affordable cost in Delhi, India. Advanced endoscopic Septoplasty for nasal blockage and breathing issues by top ENT specialists" />
            <meta name="keywords" content="Septoplasty Surgery, Septoplasty Cost, Septoplasty cost in India, Endoscopic Septoplasty Cost, Endoscopic Septoplasty Surgery, Septoplasty Surgery in Delhi" />
            <link rel="canonical" href="https://entdelhi.com/septoplasty/" />
            <meta property="og:title" content="Septoplasty Surgery in Delhi, India | Treatment, Cost & Doctors" />
            <meta property="og:description" content="Get expert Septoplasty surgery with affordable cost in Delhi, India. Advanced endoscopic Septoplasty for nasal blockage and breathing issues by top ENT specialists" />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
